
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Klepněte na „Otevřít v prohlížeči…“`,
's182ab2d6c997515f': `Přidejte jej na plochu pro rozšířené využití a snadný přístup.`,
's224cbcec014ef6b5': `Stiskněte tlačítko Sdílet na navigačním panelu`,
's233af3b7eb5e0364': `Přidat do košíku`,
's37a9e8aec5713460': `Více`,
's4c3161035f3a1413': `Stiskněte tlačítko nabídky`,
's4e1e10a6ca408245': `Klepněte na "Přidat na plochu"`,
's6196153c4b0c1ea0': `Nainstalovat`,
's633502f7cff4f847': `Otevřete nabídku prohlížeče`,
's681e399d63311fba': `Zobrazit galerii`,
's6d14a4f70ba4e3cf': `Stiskněte tlačítko nabídky, pokud není ikona Sdílet`,
's922329d6f6213590': `Přidat do Docku`,
's9c63a79ffcc2a3a3': `Stiskněte "Přidat na plochu"`,
'sa2d71bfd9525168d': `Stiskněte "Přidat do Docku"`,
'sa5ef80b4bb9b39f8': `Méně`,
'sb527eca1c1d7e7be': `Otevřete nabídku prohlížeče v aplikaci`,
'sba52286c21552a4e': `Nainstalujte si jej na své zařízení pro rozšířené využití a snadný přístup.`,
'sc16e00a7a8b2fde2': `Zpět`,
'scdaf4bbff76674c8': `Přidat na plochu`,
'sd18a5b85f599ff3c': `Otevřete zkopírovaný odkaz v Safari`,
'se72fc3a84f9b51c3': `Klepnutím zkopírujete odkaz`,
'se740f75b95a51807': `Přidejte jej do svého Docku pro rozšířené využití a snadný přístup.`,
'sfa6c42cdf48d93d2': `Tento prohlížeč to ale nepodporuje. Chcete-li pokračovat, otevřete odkaz v externím prohlížeči.`,
'sfb78526365796a41': `Stiskněte "Zobrazit více" v nabídce Sdílet`,
'sfea652f6580ff086': `Tento web má funkce aplikace.`,
    };
  